module.exports = __webpack_public_path__ + "static/bingo-menu-d5abe2114ec0bd42b39c48beba0d5dc0.png";